<template>
  <dialog-base
    :visible.sync="visible"
    title="Chọn tài khoản thanh toán trực tuyến"
    size="md"
    :use-panel="false"
    :confirm-loading="loading"
    confirm-text="Lưu"
    cancel-text="Đóng"
    @confirm="handleSubmit"
    @cancel="handleClose"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :rules="formRules"
      label-position="left"
      label-width="155px"
      class="sk-dialog-content"
      v-loading="formLoading"
    >
      <div class="sk-panel">
        <div class="sk-panel-head">
          <div class="sk-panel-icon"><i class="el-icon-bank-card" /></div>
          <div>
            <p class="sk-panel-title">Chọn tài khoản thanh toán</p>
            <p class="sk-panel-subtitle">
              Áp dụng cho {{ selectedCount }} phiếu thu đã chọn
            </p>
          </div>
        </div>

        <el-form-item label="Tài khoản" prop="applicableBankID" class="sk-u-mt-12">
          <el-select
            v-model="dataForm.applicableBankID"
            placeholder="Chọn tài khoản ngân hàng"
            style="width: 100%"
          >
            <el-option
              v-for="item in bankList"
              :key="item.id"
              :label="item.nameAccount + ' - ' + item.numberAccount"
              :value="item.id"
            >
              <div class="flex items-center gap-2">
                <img
                  :src="item.logo"
                  alt="logo"
                  class="rbfo-bank-logo"
                />
                <span>{{ item.nameAccount }} - {{ item.numberAccount }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <div class="sk-note sk-note--warning sk-u-mt-12">
        <i class="el-icon-warning-outline" />
        <span>Tài khoản được chọn sẽ áp dụng cho tất cả phiếu thu trong danh sách.</span>
      </div>
    </el-form>
  </dialog-base>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import sePayConnectionService from "@/services/SePayConnectionService";
import ManagingStudentInvoiceService from "@/services/tutition_v3/ManagingStudentInvoiceService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "RegisterBankForOrderDialog",
  components: { DialogBase },

  data() {
    return {
      visible: false,
      loading: false,
      formLoading: false,
      selectedCount: 0,
      bankList: [],
      idxList: [],
      dataForm: {
        applicableBankID: null,
      },
      formRules: {
        applicableBankID: [
          { required: true, message: "Vui lòng chọn tài khoản", trigger: "change" },
        ],
      },
    };
  },

  methods: {
    /**
     * Mở dialog từ parent
     * @param {Object} params - { idxList: Array<String> }
     */
    open(params = {}) {
      const { idxList = [] } = params;
      this.idxList = idxList;
      this.selectedCount = idxList.length;
      this.dataForm.applicableBankID = null;
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.dataForm?.clearValidate();
        this.fetchBankList();
      });
    },

    async fetchBankList() {
      this.formLoading = true;
      try {
        const response = await sePayConnectionService.findListBankForSchool();
        this.bankList = response?.data?.data || [];
      } catch (error) {
        console.error(error);
        NotifyMessage.leftCornerNotificationError("Không thể tải danh sách tài khoản ngân hàng.");
        this.bankList = [];
      } finally {
        this.formLoading = false;
      }
    },

    handleSubmit() {
      this.$refs.dataForm.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          const payload = {
            applicableBankID: this.dataForm.applicableBankID,
            idx: this.idxList,
          };
          await ManagingStudentInvoiceService.registerBankForInvoice(payload);
          NotifyMessage.leftCornerNotificationSuccess("Áp dụng tài khoản thanh toán thành công.");
          this.$emit("saved");
          this.handleClose();
        } catch (error) {
          console.error(error);
          NotifyMessage.leftCornerNotificationError(
            error?.response?.data?.message || "Áp dụng tài khoản thanh toán thất bại."
          );
        } finally {
          this.loading = false;
        }
      });
    },

    handleClose() {
      this.visible = false;
      this.loading = false;
      this.$refs.dataForm?.resetFields();
      this.dataForm.applicableBankID = null;
      this.bankList = [];
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";

.rbfo-bank-logo {
  width: 24px;
  height: 24px;
  object-fit: contain;
  border-radius: 4px;
}
</style>
